const firebaseConfig = {
    apiKey: "AIzaSyCc267_TogP0cNbIJDfFWHJ8H-5BRiRwxg",
    authDomain: "hospital-info-55fc1.firebaseapp.com",
    projectId: "hospital-info-55fc1",
    storageBucket: "hospital-info-55fc1.appspot.com",
    messagingSenderId: "932559986908",
    appId: "1:932559986908:web:13cd676409b73b3e1e5419",
    measurementId: "G-9FX7XZKJ9W"
  };
  export default firebaseConfig;